import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import ItemLine from './ItemLine';

import { updateSelectedItems, searchProducts, resetProducts } from '../../redux/actions/products';
import { getCategories } from '../../redux/actions/categories';

import { assignmentsCreate, reset } from '../../redux/actions/assignments';

const CreateSupplierAssignments = ({ payload, setActiveTab, assignments, activeSupplier, isSearching, searchedProducts, searchedProductsPagination, searchedvariations, selectedProductList, categories, submitSearch, loadCategories, setSelectedProductList, createAssignments, resetAssignments, resetProductSearch, selectedProductCount }) => {
  const [submitted, setSubmitted] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [inStockFilter, setInStockFilter] = useState(false);
  const [purchasingDisabledFilter, setPurchasingDisabledFilter] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState();

  const [showFilters, setShowFilters] = useState(false);


  const [assignmentValues, setAssignmentValues] = useState({
    'supplierPrices': { 'product': {}, 'variation': {} },
    'minOrders': { 'product': {}, 'variation': {} },
    'supplierSkus': { 'product': {}, 'variation': {} },
    'orderMultiples': { 'product': {}, 'variation': {} },
    'packQuantities': { 'product': {}, 'variation': {} },
  })

  const [enqueueSearch, setEnqueueSearch] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    resetProductSearch();
    resetAssignments();
    loadCategories(payload);
    setAssignmentValues({
      'supplierPrices': { 'product': {}, 'variation': {} },
      'minOrders': { 'product': {}, 'variation': {} },
      'supplierSkus': { 'product': {}, 'variation': {} },
      'orderMultiples': { 'product': {}, 'variation': {} },
      'packQuantities': { 'product': {}, 'variation': {} },
    });
    setSelectedProductList({ variations: {}, products: {} });
  }, []);

  useEffect(() => {
    if(assignments.status === 'created') {
      setActiveTab('view');
    }
  }, [assignments]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if(searchTerm !== ''){
        setCurrentPage(1);
        handleSearch(searchTerm, 1);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm, 500]);

  const handleSearch = (searchTerm, page) => {
    if(!isSearching) {
      setEnqueueSearch(null);
      submitSearch(payload, searchTerm, inStockFilter, categoryFilter);
    } else {
      setEnqueueSearch(searchTerm);
    }
  }
  
  useEffect(() => {
    if(!isSearching) {
      readySearch();
    }
  }, [isSearching]);
  
  const readySearch = () => {
    if(enqueueSearch) {
      submitSearch(payload, enqueueSearch, inStockFilter, categoryFilter);
      setEnqueueSearch(null);
    }
  }

  useEffect(() => {
    handleSearch(searchTerm);
  }, [inStockFilter]);

  useEffect(() => {
    handleSearch(searchTerm);
  }, [categoryFilter]);
  
  const toggleInStockFilter = () => {
    setInStockFilter(!inStockFilter);
  }

  const togglePurchasingDisabledFilter = () => {
    setPurchasingDisabledFilter(!purchasingDisabledFilter);
  }
  
  // const switchCategoryFilter = (event, setter) => {
  //   let categoryId = event.hash;
  //   setter(categoryId);
  // }

  const switchCategoryFilter = (event) => {
    setCategoryFilter(event.target.value);
  }

  const setProductResultPage = (page) => {
    setCurrentPage(page);
    handleSearch(searchTerm, page);
  }

  const clearCategory = () => {
    setCategoryFilter(null);
  }

  const validateTerm = (event) => {
    let value = event.target.value;

    setSearchTerm(value);
    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const selectAllSearched = () => {
    let productSection = selectedProductList.products;
    let variationsSection = selectedProductList.variations;

    searchedProducts.forEach((product) => {
      let productInList = Object.keys(productSection).indexOf(String(product.id)) > -1;
      if (!productInList && product.combinations.length === 0) {

        if(product.quantity > 0 || !inStockFilter) {
          let upc = product.attrs.find(attr => attr.name === 'UPC')?.value;
          let brand = product.attrs.find(attr => attr.name === 'Brand')?.value;

          productSection[String(product.id)] = {
            sku: product.sku,
            smallThumbnailUrl: product.smallThumnailUrl,
            options: product.options,
            name: product.name,
            quantity: product.quantity,
            price: product.price,
            upc: upc,
            brand: brand,
            productId: product.id,
          }
        }

      }

      product?.combinations?.forEach((combination) => {
        let combinationInList = Object.keys(variationsSection).indexOf(String(combination.id)) > -1;
        if (!combinationInList) {

          if(((combination.quantity || product.quantity) > 0) || !inStockFilter) {
            let upc = combination.attrs.find(attr => attr.name = 'UPC')?.value;
            let brand = product.attrs.find(attr => attr.name === 'Brand')?.value;

            variationsSection[String(combination.id)] = {
              sku: combination.sku,
              smallThumbnailUrl: combination.smallThumnailUrl || product.smallThumbnailUrl,
              options: combination.options,
              name: combination.name || product.name,
              quantity: combination.quantity || product.quantity,
              price: combination.price || combination.defaultDisplayedPrice || product.price,
              upc: upc,
              brand: brand,
              productId: product.id,
            }
          }

        }
      })
    })

    setSelectedProductList({ ...selectedProductList });
  }

  const setSupplierPrice = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.supplierPrices[type][itemId] = event.target.value;

    setAssignmentValues(assignValues);
  }

  const setSupplierMinOrder = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.minOrders[type][itemId] = parseInt(event.target.value).toString();

    setAssignmentValues(assignValues);
  }

  const setSupplierSku = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.supplierSkus[type][itemId] = event.target.value;

    setAssignmentValues(assignValues);
  }

  const setOrderMultiple = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.orderMultiples[type][itemId] = parseInt(event.target.value).toString();

    setAssignmentValues(assignValues);
  }

  const setPackQuantity = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.packQuantities[type][itemId] = parseInt(event.target.value).toString();

    setAssignmentValues(assignValues);
  }

  const deselectAllSelected = () => {
    setSelectedProductList({ variations: {}, products: {} });
  }

  const validatePage = (event) => {
    let page = event.target.value;

    if (page < 1) {
      page = 1;
    }

    if (page > searchedProductsPagination.total_pages) {
      page = searchedProductsPagination.total_pages;
    }

    setCurrentPage(page);
  }

  const submitPage = () => {
    handleSearch(searchTerm, currentPage);
  }

  const handleSubmit = () => {
    setSubmitted(true);
    createAssignments(payload, activeSupplier.id, selectedProductList, assignmentValues);
  }

  const toggleFilters = (event) => {
    if(showFilters) {
      setShowFilters(false);
      event.target.parentElement.classList.remove("collapsible--opened");
    } else {
      setShowFilters(true);
      event.target.parentElement.classList.add("collapsible--opened");
    }
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  return (
    <>

      <div className="a-card a-card--compact">
        <div className="a-card__paddings">
          <div className="iconable-block iconable-block--hide-in-mobile">
            <div className="iconable-block__infographics">
              <span className="iconable-block__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 7c0 3.866-3.134 7-7 7-1.5724 0-3.0236-.5184-4.1922-1.3936l-4.1007 4.1007c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3906-.3905-1.0237 0-1.4143l4.1007-4.1007C4.5184 10.0236 4 8.5723 4 7c0-3.866 3.134-7 7-7s7 3.134 7 7zm-2 0c0 2.7614-2.2386 5-5 5S6 9.7614 6 7s2.2386-5 5-5 5 2.2386 5 5z"/></svg>
              </span>
            </div>
            <div className="iconable-block__content">
              <div className="status-block">
                <div className="status-block__central">
                  <div className="status-block__header">
                    <span className="status-block__title">
                      Catalog Search
                      { isSearching && 
                        <div className="left-15 canonical-status text-default canonical-status--info canonical-status--loading canonical-status--has-icon canonical-status--prepend-icon">
                          <div className="canonical-status__icon">
                            <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" width="28" height="28">
                              <path d="M14,27C6.83,27,1,21.17,1,14c0-1.56,0.27-3.08,0.81-4.52C2.1,8.7,2.96,8.31,3.74,8.59c0.78,0.29,1.17,1.15,0.88,1.93 C4.21,11.63,4,12.8,4,14c0,5.51,4.49,10,10,10c5.51,0,10-4.49,10-10c0-5.51-4.49-10-10-10c-0.83,0-1.5-0.67-1.5-1.5S13.17,1,14,1 c7.17,0,13,5.83,13,13C27,21.17,21.17,27,14,27z"></path>
                            </svg>
                          </div>
                        </div>
                      }
                    </span>
                    <span className="status-block__edit">Edit</span>
                  </div>
                  <div className="status-block__content">
                    <div className="fieldset full-width">
                      <div className="field field--medium">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">Search</label>
                        <input type="text" value={searchTerm} onFocus={focus} onBlur={blur} onChange={validateTerm} className="field__input" tabindex="4" maxlength="64" />
                        <div className="field__placeholder">Search</div>
                        <span className="field-state--success"></span>
                        <span className="field-state--close"></span>
                      </div>
                      <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>

                      <div class="collapsible top-15 padding-15 a-card__darken search-filters" onClick={(e) => toggleFilters(e)}>
                        <div class="collapsible__header">Search filters</div>
                        <div class="collapsible__body">

                          <div className="flex-container">
                            <div className="element flex-1">
                              <div className="element__title">
                                In Stock
                              </div>
                              <label className="checkbox tiny">
                                { inStockFilter && <input type="checkbox" checked="true" onClick={() => toggleInStockFilter()}/>}
                                { !inStockFilter && <input type="checkbox" onClick={() => toggleInStockFilter()}/>}
                                <div><div></div></div>
                              </label>
                            </div>

                            <div className="flex-1">
                              { !categories.isFetching && categories.status === "success" &&
                                <>
                                  <div className="fieldset fieldset--select">
                                    <div className="field field--medium field--filled">
                                      <label className="field__label">Category</label>
                                      <select value={categoryFilter} id="categoryFilter" onChange={(e) => switchCategoryFilter(e)} className="field__select">
                                        <option hidden disabled selected value></option>
                                        { Object.entries(categories.categories).map(([key, name]) =>
                                          <option value={key}>{name}</option>
                                        )}
                                      </select>

                                      <div className="field__placeholder">Category</div>
                                    </div>
                                  </div>
                                  <button className="left-15 bottom-5 btn btn-link btn-medium" onClick={() => clearCategory()}>
                                    Clear Category
                                  </button>
                                </>
                              }
                              { categories.isFetching &&
                                <LoadingSpinner statusText="Loading categories" />
                              }
                            </div>
                          </div>

                        </div>
                      </div>

                      { searchedProducts && searchedProducts.length > 0 &&
                        <button className="top-5 btn btn-primary-accent btn-medium" onClick={() => selectAllSearched()}>Select All Searched Items</button>
                      }
                      { (!searchedProducts || searchedProducts.length === 0) &&
                        <button className="top-5 btn btn-primary-accent btn-medium" disabled>Select All Searched Items</button>
                      }

                      { (Object.keys(selectedProductList.products).length + Object.keys(selectedProductList.variations).length ) > 0 &&
                        <button className="top-5 left-15 btn btn-primary-accent btn-medium" onClick={() => deselectAllSelected()}>Deselect All Selected Items</button>
                      }
                      { (Object.keys(selectedProductList.products).length + Object.keys(selectedProductList.variations).length ) === 0 &&
                        <button className="top-5 left-15 btn btn-primary-accent btn-medium" disabled>Deselect All Selected Items</button>
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="a-card a-card--compact">
        <div className="">
          { isSearching && 
            <>
              <LoadingSpinner statusText="Searching products" /> 
              <br/>
              <br/>
            </>        
          }

          { !isSearching && searchedProducts !== null && 
            <>
              <button
                className={`btn btn-primary btn-medium ${ submitted ? 'btn-loading' : '' }`}
                onClick={() => handleSubmit()}
                disabled={ submitted || ((Object.keys(selectedProductList.products).length + Object.keys(selectedProductList.variations).length) === 0) }
              >
                Submit New Product Assignments
              </button>
            </>
          }


          { !isSearching && 
            <div className="filtered-list__items long-list">
              { (searchTerm !== '' || categoryFilter) && searchedProducts !== null && 
                <div>
                  { searchedProducts.map(product => 
                      <>
                        { product.combinations.length === 0 &&
                          <ItemLine
                            payload={payload}
                            productId={product.id}
                            itemId={product.id}
                            sku={product.sku}
                            upc={product.attrs.find(attr => attr.name === 'UPC')?.value || false}
                            brand={product.attrs.find(attr => attr.name === 'Brand')?.value || false}
                            name={product.name}
                            options={false}
                            smallThumbnailUrl={product.smallThumbnailUrl}
                            rowId={product.id}
                            type={'product'}
                            quantity={product.quantity}
                            price={product.price}
                            inStockFilter={inStockFilter}
                            supplierPrice={assignmentValues.supplierPrices.product[product.id]}
                            minOrder={assignmentValues.minOrders.product[product.id]}
                            supplierSku={assignmentValues.supplierSkus.product[product.id]}
                            orderMultiple={assignmentValues.orderMultiples.product[product.id]}
                            packQuantity={assignmentValues.packQuantities.product[product.id]}
                            setSupplierPrice={setSupplierPrice}
                            setSupplierMinOrder={setSupplierMinOrder}
                            setSupplierSku={setSupplierSku}
                            setOrderMultiple={setOrderMultiple}
                            setPackQuantity={setPackQuantity}
                            submitted={submitted}
                            supplierId={activeSupplier.id}
                          />
                        }
                        { product?.combinations?.map(combination =>
                            <ItemLine
                              payload={payload}
                              productId={product.id}
                              itemId={combination.id}
                              name={product.name}
                              sku={combination.sku}
                              upc={combination.attrs.find(attr => attr.name === 'UPC')?.value || false}
                              brand={combination.attrs.find(attr => attr.name === 'Brand')?.value || false}
                              options={combination.options}
                              smallThumbnailUrl={combination.smallThumbnailUrl || product.smallThumbnailUrl}
                              rowId={combination.id}
                              type={'variation'}
                              quantity={combination.quantity || product.quantity}
                              price={combination.price || combination.defaultDisplayedPrice || product.price}
                              inStockFilter={inStockFilter}
                              supplierPrice={assignmentValues.supplierPrices.variation[combination.id]}
                              minOrder={assignmentValues.minOrders.variation[combination.id]}
                              supplierSku={assignmentValues.supplierSkus.variation[combination.id]}
                              orderMultiple={assignmentValues.orderMultiples.variation[combination.id]}
                              packQuantity={assignmentValues.packQuantities.variation[combination.id]}
                              setSupplierPrice={setSupplierPrice}
                              setSupplierMinOrder={setSupplierMinOrder}
                              setOrderMultiple={setOrderMultiple}
                              setPackQuantity={setPackQuantity}
                              setSupplierSku={setSupplierSku}
                              submitted={submitted}
                              supplierId={activeSupplier.id}

                            />
                          )
                        }
                      </>
                    )
                  }
              </div>
              }
            </div>
          }

          { searchedProducts === null &&
            <>
              <span className="text-default">
                <strong>{ selectedProductCount } </strong>
                Items selected
              </span>
              <div className="filtered-list">
                <div className="filtered-list__items long-list">
                  { selectedProductList.products && Object.keys(selectedProductList.products).map(itemId => 
                      <ItemLine
                        payload={payload}
                        itemId={itemId}
                        sku={selectedProductList.products[itemId].sku}
                        upc={selectedProductList.products[itemId].upc}
                        name={selectedProductList.products[itemId].name}
                        options={false}
                        smallThumbnailUrl={selectedProductList.products[itemId].smallThumbnailUrl}
                        rowId={itemId}
                        type={'product'}
                        price={selectedProductList.products[itemId].price}
                        inStockFilter={inStockFilter}
                        supplierPrice={assignmentValues.supplierPrices.product[product.id]}
                        minOrder={assignmentValues.minOrders.product[product.id]}
                        supplierSku={assignmentValues.supplierSkus.product[product.id]}
                        setSupplierPrice={setSupplierPrice}
                        setSupplierMinOrder={setSupplierMinOrder}
                        setSupplierSku={setSupplierSku}
                        setOrderMultiple={setOrderMultiple}
                        setPackQuantity={setPackQuantity}
                        submitted={submitted}
                        supplierId={activeSupplier.id}
                      />
                    )
                  }
                  { selectedProductList.variations && Object.keys(selectedProductList.variations).map(itemId => 
                      <ItemLine
                        payload={payload}
                        itemId={itemId}
                        sku={selectedProductList.variations[itemId].sku}
                        upc={selectedProductList.variations[itemId].upc}
                        name={selectedProductList.variations[itemId].name}
                        options={selectedProductList.variations[itemId].options}
                        smallThumbnailUrl={selectedProductList.variations[itemId].smallThumbnailUrl}
                        rowId={itemId}
                        type={'variations'}
                        price={selectedProductList.variations[itemId].price}
                        inStockFilter={inStockFilter}
                        supplierPrice={assignmentValues.supplierPrices.variation[itemId]}
                        minOrder={assignmentValues.minOrders.variation[itemId]}
                        supplierSku={assignmentValues.supplierSkus.variation[itemId]}
                        setSupplierPrice={setSupplierPrice}
                        setSupplierMinOrder={setSupplierMinOrder}
                        setSupplierSku={setSupplierSku}
                        setOrderMultiple={setOrderMultiple}
                        setPackQuantity={setPackQuantity}
                        submitted={submitted}
                        supplierId={activeSupplier.id}
                      />
                    )
                  }
                </div>
              </div>
            </>
          }

        </div>
      </div>

    </>
  )

}


const mapStateToProps = state => ({
  isSearching: state.products.isFetching,
  selectedProductCount: Object.keys(state.products.selectedProductList.variations).length + Object.keys(state.products.selectedProductList.products).length,
  searchedProducts: state.products.searchedProducts,
  searchedProductsPagination: state.products.searchedProductsPagination,
  searchedvariations: state.products.searchedvariations,
  selectedProductList: state.products.selectedProductList,
  categories: state.categories,
  assignments: state.assignments
});

const mapDispatchToProps = (dispatch) => ({
  submitSearch: (payload, searchTerm, inStockFilter, categoryFilter) => dispatch(searchProducts(payload, searchTerm, inStockFilter, categoryFilter)),
  loadCategories: (payload) => dispatch(getCategories(payload)),
  setSelectedProductList: (items) => dispatch(updateSelectedItems(items)),

  createAssignments: (payload, supplierId, assignments, assignmentValues) => dispatch(assignmentsCreate(payload, supplierId, assignments, assignmentValues)),
  resetAssignments: () => dispatch(reset()),
  resetProductSearch: () => dispatch(resetProducts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateSupplierAssignments);
